import { render, staticRenderFns } from "./RecipePicker.vue?vue&type=template&id=8ec174ca"
import script from "./RecipePicker.vue?vue&type=script&lang=js"
export * from "./RecipePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports